import { cn } from 'utils/cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-muted dark:bg-background animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export default Skeleton;
